import React from "react";

import { BrandLicense } from "@/custom-types/Brand";

type Props = {
  brandLicenses: Array<BrandLicense>;
};

const BrandLicenses: React.FC<Props> = ({ brandLicenses }) => {
  return (
    <div className="mt-md">
      <p className="text-xs font-extrabold uppercase mb-sm">License(s)</p>
      <ul>
        {brandLicenses.map((license: BrandLicense) => (
          <li data-testid="brand-license" key={license.licenseNumber}>
            <span className="font-bold">
              {[license.state, license.country].filter(Boolean).join(", ")}:
            </span>{" "}
            {license.licenseNumber}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BrandLicenses;
